import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'jft-revision-final-base-amount',
    templateUrl: './revision-final-base-amount.component.html',
    styleUrls: ['./revision-final-base-amount.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RevisionFinalBaseAmountComponent implements OnInit {
    @Input() public baseCurrencyCode;
    @Input() public finalBaseAmount;

    constructor() {
    }

    ngOnInit(): void {
    }

}
